<template>
  <span>
    <strapi-image v-bind="$props" :class="{ rounded }" />
    <img
      v-if="image.overlay && !ignoreOverlay"
      ref="imageOverlay"
      fetchpriority="high"
      :class="imgCSSOverlay"
      :alt="image.overlay.alternativeText || 'Overlay'"
      :src="image.overlay.url"
    />
  </span>
</template>

<script setup lang="ts">
import type { StrapiImage } from '#variant/apollo/types/types';

const props = withDefaults(
  defineProps<{
    image: StrapiImage;
    forceWidth?: number;
    forceHeight?: number;
    alt?: string;
    altFallback?: string;
    lazy?: boolean;
    autoScale?: boolean;
    imageClass?: string;
    overlayClass?: string;
    fluid?: boolean;
    rounded?: boolean;
    asBackground?: boolean;
    ignoreOverlay?: boolean;
  }>(),
  {
    forceWidth: undefined,
    forceHeight: undefined,
    alt: undefined,
    altFallback: undefined,
    lazy: true,
    autoScale: false,
    imageClass: undefined,
    overlayClass: undefined,
    fluid: false,
    rounded: false,
    asBackground: false,
    ignoreOverlay: false,
  },
);

const imgCSSOverlay = computed<string[]>(() => {
  const cssClasses = props.overlayClass ? [props.overlayClass] : [];
  cssClasses.push('absolute top-0 left-0 object-cover');

  if (props.asBackground) {
    cssClasses.push('h-full w-full');
  }

  if (props.rounded) {
    cssClasses.push('rounded');
  }

  return cssClasses;
});
</script>
